const addUserIdToDataLayer = (userId) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'user-id': userId,
  });
};

export const gaDataLayerEvent = (eventName, eventValue) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    event_value: eventValue,
  });
};

export const gaPageViewEvent = (eventName, eventValue, pageTitle) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    event_value: eventValue,
    page_title: pageTitle,
  });
};

export const trackActivityPostData = (trackingKey, postData) => {
  let postDataForTracking = postData.communityId ? `Community_${postData.communityId}` : 'HomePage';
  if (postData.id) {
    postDataForTracking = `${postDataForTracking} | Post_${postData.id}`;
  }
  if (postData.parentPostId) {
    postDataForTracking = `${postDataForTracking} | ParentPost_${postData.parentPostId}`;
  }
  gaDataLayerEvent(trackingKey, postDataForTracking);
};


export function setUserId(userId) {
  addUserIdToDataLayer(userId);
  const user = {
    userId: userId,
  }
  sessionStorage.setItem('user', JSON.stringify(user));
}
